var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurantLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 69,
    viewBox: "0 0 77 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.258789,
    y: 0.171875,
    width: 76.4828,
    height: 67.8893,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2793,
    y: 60.1221,
    width: 14.0362,
    height: 60.155,
    transform: "rotate(-90 8.2793 60.1221)",
    fill: "#F1F3F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2793,
    y: 41.1934,
    width: 34.0879,
    height: 60.155,
    transform: "rotate(-90 8.2793 41.1934)",
    fill: "#FDF6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4091 22.9947C46.3463 22.9947 47.918 21.3949 47.918 19.423C47.918 17.4511 46.3463 15.8513 44.4091 15.8513C43.1116 15.8513 41.9749 16.5693 41.3681 17.6371H39.4456C40.1693 15.5574 42.1174 14.0654 44.4091 14.0654C47.3149 14.0654 49.6724 16.4652 49.6724 19.423C49.6724 22.3808 47.3149 24.7805 44.4091 24.7805C43.3967 24.7805 42.4537 24.4903 41.6496 23.9881L42.9435 22.671C43.3894 22.8794 43.8865 22.9947 44.4091 22.9947ZM28.685 19.3783C28.8203 19.0435 29.1419 18.8277 29.4965 18.8277H42.9471C43.3016 18.8277 43.6233 19.0435 43.7585 19.3783C43.8938 19.7132 43.8207 20.0964 43.5685 20.3531L37.099 26.9385V31.3287H39.4382C39.9244 31.3287 40.3155 31.7268 40.3155 32.2216C40.3155 32.7164 39.9244 33.1145 39.4382 33.1145H36.2218H33.0053C32.5192 33.1145 32.1281 32.7164 32.1281 32.2216C32.1281 31.7268 32.5192 31.3287 33.0053 31.3287H35.3446V26.9347L28.8751 20.3531C28.6229 20.0964 28.5498 19.7132 28.685 19.3783Z",
    fill: "#CC5803"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantLogo);
export default __webpack_public_path__ + "static/media/RestaurantLogo.eb32ee0b33f4592a93f4b02b89150bfa.svg";
export { ForwardRef as ReactComponent };